__turbopack_context__.v({
  "footerContainer": "uHw_oG_footerContainer",
  "footerHeader": "uHw_oG_footerHeader",
  "footerSubHeader": "uHw_oG_footerSubHeader",
});
